
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import router from "@/router";

export default {
  setup() {
    const store = useStore();
    const toast = useToast();


    const homeMenu = computed(() => {
      const menu = ref([
        {
          label:'Trang chủ',
          icon:'pi pi-fw pi-home',
          to: '/'
        },
        // {
        //   label:'Thống kê bệnh nhân',
        //   icon:'pi pi-fw pi-users',
        //   to: '/thongkebenhnhan'
        // },
        {
          label:'Thống kê doanh thu',
          icon:'pi pi-fw pi-dollar',
          to: '/thongkedoanhthu'
        },
        {
          label:'Thống kê trực tuyến',
          icon:'pi pi-fw pi-sync',
          to: '/thongtintructuyen'
        },
      ]);
      return menu.value;
    })


    return {
      homeMenu,
    }
  }
}
